import styled from 'styled-components';
import { PaymentAgreementText } from '@/components/Payment/PaymentAgreementText';

export const LoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const AgreementText = styled(PaymentAgreementText)`
  margin-top: 20px;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 15px;
    padding: 0;
  }
`;
